import { render, staticRenderFns } from "./PerformanceSummary.vue?vue&type=template&id=54f2ee10"
import script from "./PerformanceSummary.vue?vue&type=script&lang=js"
export * from "./PerformanceSummary.vue?vue&type=script&lang=js"
import style0 from "./PerformanceSummary.vue?vue&type=style&index=0&id=54f2ee10&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f2ee10')) {
      api.createRecord('54f2ee10', component.options)
    } else {
      api.reload('54f2ee10', component.options)
    }
    module.hot.accept("./PerformanceSummary.vue?vue&type=template&id=54f2ee10", function () {
      api.rerender('54f2ee10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PerformanceSummary.vue"
export default component.exports